import { Component } from 'react';
import { authenticationService } from '../services/authentication-service';
import { GRAPH_REQUESTS } from '../../../common/APIConstants';

import SessionStorageService from '../../../common/services/session-storage-service';

const tokenResponse = {
    token: '',
    userName: '',
    displayName: '',
    roles: [],
    accessToken: '',
    refreshReportToken: ''
}

class AuthProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: null,
            error: null,
            IsLoggedIn: false,
            UserName: null
        }
    }
    static async acquireToken(request) {
        let idToken = await authenticationService.acquireTokenSilent(GRAPH_REQUESTS.LOGIN);
        if (idToken) {
            return idToken;
        }
        else {
            return authenticationService.acquireTokenPopup(GRAPH_REQUESTS.LOGIN);
        }
    }
    static async acquireTokenUserScope() {
        let idToken = await authenticationService.acquireTokenSilent(GRAPH_REQUESTS.GETUSERS);
        return idToken.value;
    }
    static async acquireTokenSilent() {
        try {
            const idToken = await authenticationService.acquireTokenSilent(GRAPH_REQUESTS.LOGIN);
            return Promise.resolve({
                token: idToken.value,
                userName: idToken.userName,
                displayName: idToken.displayName,
                IsLoggedIn: true,
                roles: idToken.roles
            });
        } catch (error) {
            let idToken = await authenticationService.acquireTokenPopup(GRAPH_REQUESTS.LOGIN);
            return Promise.resolve({
                token: idToken.value,
                userName: idToken.userName,
                displayName: idToken.displayName,
                IsLoggedIn: true,
                roles: idToken.roles
            });
        }
    }

    static async getUserNamePostLogin() {
        let idToken = await authenticationService.acquireTokenSilent(GRAPH_REQUESTS.LOGIN);
        if (idToken) {
            tokenResponse.token = idToken.value;
            tokenResponse.userName = idToken.userName;
            tokenResponse.displayName = idToken.displayName;
            tokenResponse.roles = idToken.roles;
            tokenResponse.accessToken = idToken.value;
            return tokenResponse;
        }
        else {
            return authenticationService.acquireTokenPopup(GRAPH_REQUESTS.LOGIN);
        }
    }

    static async getReportToken() {
        let idToken = await authenticationService.acquireTokenSilent(GRAPH_REQUESTS.REPORT);
        tokenResponse.accessToken = idToken.value;
        return tokenResponse;
    }

    static async getRefreshReportToken() {
        let idToken = await authenticationService.acquireTokenSilent(GRAPH_REQUESTS.REFRESH_REPORT);
        tokenResponse.refreshReportToken = idToken.value;
        return tokenResponse;
    }

    static async onSignIn() {
        let idToken = await authenticationService.acquireTokenPopup(GRAPH_REQUESTS.SIGNIN);
        return Promise.resolve({
            token: idToken.value,
            userName: idToken.userName,
            displayName: idToken.displayName,
            IsLoggedIn: true,
            roles: idToken.roles,
            accessToken: idToken.value
        });
    }
    static onSignOut() {
        SessionStorageService.removeAuthToken();
        authenticationService.logout();
    }
    async componentDidMount() {
        authenticationService.handleRedirectCallback(error => {
            if (error) {
                const errorMessage = error.errorMessage
                    ? error.errorMessage
                    : 'Unable to acquire access token'
                this.setState({
                    error: errorMessage
                })
            }
        })

        const account = authenticationService.getUser();
        if (account) {
            this.setState({ account });
        }
        else {
            this.onSignIn();
        }
    }
}

export default AuthProvider;